/**
 * Different strokes for different (funding) folks.
 */
// NAWI
import aquaflowizLogoFull from './assets/flowiz-full-logo.png';
import aquaflowizLogo from './assets/flowiz-logo.png';
import flowizSplash from './assets/flowiz-splash.png';
// PROMMIS
import prommisLogoFull from './assets/prommis-full-logo.png';
import prommisLogo from './assets/prommis-logo.png';
import prommisSplash from './assets/prommis-splash.png';
// IDAES
import idaesLogoFull from './assets/idaes-full-logo.png';
import idaesLogo from './assets/idaes-logo-white.png';
import idaesSplash from './assets/idaes-splash.png';

// Configure all possible themes
export const themes = {
    Aquaflowis: {
        project: 'Aquaflowiz',
        projectTitle: 'Aquaflowiz',
        projectBlurb: 'The Water treatment Technoeconomic Assessment Platform ' +
            '(Aquaflowiz) is a comprehensive Python-based software package that ' +
            'supports the technoeconomic assessment of full water treatment trains.',
        projectRelease: {
            'version': '24.11.20', 'depVersions': {
                'Aquaflowiz': '1.1.0'
            }
        },
        splashImage: flowizSplash,
        logoFull: aquaflowizLogoFull,
        logoOnly: aquaflowizLogo,
        header: {
            color: '#FFFFFF', 
            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)', 
            logoBackground: '#F8FAFF'
        },
        button: {
            background: '#667eea',
            hover: '#5a6fd8',
            text: '#FFFFFF'
        },
        tabs: {
            background: '#F8FAFF', 
            color: '#4A5568',
            activeBackground: '#E6EDFF',
            activeColor: '#667eea'
        },
        menuButton: {
            color: '#FFFFFF',
            hover: '#E6EDFF'
        },
        card: {
            background: '#FFFFFF',
            border: '#E2E8F0',
            shadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)'
        },
        input: {
            background: '#FFFFFF',
            border: '#D1D5DB',
            focusBorder: '#667eea',
            text: '#374151'
        },
        table: {
            headerBackground: '#F8FAFF',
            headerColor: '#4A5568',
            rowBackground: '#FFFFFF',
            alternateRowBackground: '#F8FAFF',
            border: '#E2E8F0'
        },
        status: {
            success: '#10B981',
            warning: '#F59E0B',
            error: '#EF4444',
            info: '#3B82F6'
        },
        text: {
            primary: '#1F2937',
            secondary: '#6B7280',
            muted: '#9CA3AF'
        }
    }, prommis: {
        project: 'PROMMIS',
        projectTitle: 'PROMMIS',
        projectBlurb: 'The U.S. Department of Energy’s Process Optimization and ' +
            'Modeling for Minerals Sustainability (PROMMIS) Initiative seeks to ' +
            'transform the national CM & REE landscape to meet DOE’s three ' +
            'enduring strategic objectives: security, economic competitiveness, ' +
            'and environmental responsibility',
        projectRelease: {
            'version': '0.3.1', 'depVersions': {
                'Aquaflowis': '0.12.0'
            }
        },
        splashImage: prommisSplash,
        logoFull: prommisLogoFull,
        logoOnly: prommisLogo,
        header: {
            color: '#000000', background: '#F6F4F4', logoBackground: '#F8F6F6'
        },
        button: {
            background: '#1669B6',
        },
        tabs: {
            background: '#F6F4F4', color: '#727272'
        },
        menuButton: {
            color: '#99AA99'
        }
    }, idaes: {
        project: 'IDAES',
        projectTitle: 'IDAES',
        projectBlurb: 'The  Institute for Design of Advanced Energy Systems (IDAES) ' +
            'integrated platform utilizes computational algorithms ' +
            'to enable the design and optimization of complex, interacting energy and ' +
            'process systems ',
        projectRelease: {
            'version': '2.5.0', 'depVersions': {}
        },
        splashImage: idaesSplash,
        logoFull: idaesLogoFull,
        logoOnly: idaesLogo,
        header: {
            color: '#FFFFFF', background: '#000000', logoBackground: '#333333' // FIXME?
        },
        button: {
            background: '#333333',
        },
        tabs: {
            background: '#F1F3F3', color: '#727272'
        },
        menuButton: {
            color: '#FFFFFF'
        }
    }
}

// Aliases (keep for JS code to work!)
themes['nawi'] = themes['Aquaflowis'];

/**
 * Build version-release display string from theme's
 * 'projectRelease' data.
 *
 * Format: v<version> [(<dep1> <ver1>[, <dep2> <ver2>[, ...]]])
 *
 * @param theme
 * @returns {string}
 */
export function displayVersion(theme) {
    const rel = theme.projectRelease;

    let result = `v${rel.version}`;

    // add dependency versions, if any
    const depNames = Object.keys(rel.depVersions);
    if (depNames.length > 0) {
        const displayDeps = depNames
            .map((key) => `${key} ${rel.depVersions[key]}`)
            .join(', ');
        result += ` (${displayDeps})`;
    }

    return result;
}